import {WidthProps} from "@/styles/width.types";
import {css} from "styled-components";

const widths = {
    quarter: "25%",
    half: "50%",
    full: "100%"
};

export const width = ({width}: WidthProps) => {
    return width && css`width: ${widths[width]}`;
};
